const emailHref = (email: string) => `mailto:${email}`;

export default emailHref;
